module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/assistant/assistant.component.css
// module id = ./src/app/Pages/manage/assistant/assistant.component.css
// module chunks = main